import { Highlight, Snippet } from 'react-instantsearch-hooks-web';
import { classnames } from 'tailwindcss-classnames';
import { HitProps } from './_types';
import { useIsNRC } from 'lib/util/site-configuration';
import { ReportHeading } from './_ReportHeading';

export const renderReporttDate = (result: string | number | Date) => {
  const dateString = new Date(result);
  const options: {} = { year: 'numeric', month: 'long' };
  return (
    <div className={classnames('mb-2')}>{dateString.toLocaleDateString(undefined, options)}</div>
  );
};

export const normalizeCenterId = (centerId?: string) => {
  const normalizedInput = (centerId || ``).trim();
  // If center id does not end with a number it's "weird" and should be hidden
  if (!/\d+$/.test(normalizedInput)) {
    return '';
  }
  // Otherwise return what we got
  return normalizedInput;
};

export const ReportsHit = ({ hit }: HitProps) => {
  const isNetworkSite = useIsNRC();
  const normalizedCenterId = normalizeCenterId(hit.centerId);
  return (
    <div>
      <div className={classnames('mb-2')}>
        {isNetworkSite ? (
          <>
            <span className="searchType">REPORT</span>
            <span
              className={classnames(
                'border-r',
                'h-3',
                'mx-3',
                'inline-block',
                'border-gray-midGray'
              )}
            />
          </>
        ) : (
          <>File &emsp;| &emsp;</>
        )}
        {hit.typeOfFile}
        {normalizedCenterId.length > 0 && (
          <>
            <span className="mx-3 inline-block h-3 border-r border-gray-midGray" />
            {normalizedCenterId}
          </>
        )}
      </div>
      <ReportHeading hit={hit}>
        <Highlight hit={hit} attribute="title" />
      </ReportHeading>
      {hit.dateOfRecord && renderReporttDate(hit.dateOfRecord)}
      <Snippet
        hit={hit}
        attribute="body"
        className={classnames('line-clamp-4', 'md:line-clamp-2')}
      />
    </div>
  );
};
